/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Dummy Project Progress Tracker - Example Data (India)
=========================================================
*/

import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import { useEffect, useState } from "react";
import useDashboard from "hooks/useDashboard";
import formatRupee from "utils/formatHelper";
import { Avatar, AvatarGroup } from "@mui/material";

export default function data() {
  const { getDealersPerformance, dealersPerformance = [] } = useDashboard();
  const [data, setData] = useState([]);
  const getInitials = (name) => name.charAt(0).toUpperCase();

  const classicColors = [
    "#1E3A8A", // Navy Blue
    "#4F46E5", // Indigo
    "#0369A1", // Deep Blue
    "#334155", // Dark Gray
    "#1E40AF", // Royal Blue
    "#64748B", // Muted Gray-Blue
    "#3B82F6", // Standard Blue
    "#475569", // Soft Dark Gray
    "#2563EB", // Bright Blue
    "#1E293B", // Almost Black-Gray
  ];

  // Function to get color based on index
  const getColor = (index) => classicColors[index % classicColors.length];

  const Territory = ({ territory = [] }) => {
    return (
      <MDBox display="flex" alignItems="center">
        <AvatarGroup max={4} sx={{ flexDirection: "row-reverse" }}>
          {territory?.map((item, index) => (
            <Tooltip key={index} title={item} arrow>
              <Avatar
                sx={{
                  bgcolor: getColor(index),
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.2)",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                {getInitials(item)}
              </Avatar>
            </Tooltip>
          ))}
        </AvatarGroup>
      </MDBox>
    );
  };
  useEffect(() => {
    getDealersPerformance();
  }, []);

  const rows = data?.map((item) => ({
    bussinessName: item?.dealer?.bussinessName,
    sales: formatRupee(item?.sales),
    territory: <Territory territory={item?.territory} />,
    dealers: item?.dealer,
    progress: `${item.growth}%`,
  }));
  useEffect(() => {
    if (dealersPerformance?.dealer) {
      setData(dealersPerformance?.dealer);
    }
  }, [dealersPerformance]);

  useEffect(() => {
    getDealersPerformance();
  }, []);
  return {
    columns: [
      { Header: "Bussiness Name", accessor: "bussinessName", width: "45%", align: "left" },
      { Header: "Sales", accessor: "sales", width: "20%", align: "left" },
      { Header: "territory", accessor: "territory", align: "center" },
      { Header: "progress", accessor: "progress", align: "center" },
    ],
    rows,
  };
}
